<style>

h3{
  text-align: center;
}

.space{
  margin: 20px;
}

.optional{
  text-align: center;
  color: white;
  font-size: 16px;
}

.margin-top{
  margin-top: 40px;
  text-align: center;
}

</style>

<Auth bind:this="{auth}"></Auth>
<Profile bind:this="{profile}" bind:me="{me}"></Profile>

{#if show}

{#if add}

<SocialLinksSelect on:selected="{addLink}"></SocialLinksSelect>
  
{:else}
  
<h3>Add Social Media Links</h3>
<div class="optional">(Optional)</div>
<div class="space">
  
  <SocialLinks bind:links="{links}"></SocialLinks>
  
  <div class="margin-top">
    <button class="trans" on:click="{ () => add = true }">+ Add Link</button>
  </div>
      
</div>

{/if}

{/if}

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Auth from "../../interfaces/Auth.svelte";
let auth;

import Profile from "../../interfaces/Profile.svelte";
let profile;

import Validate from "../../helpers/Validate.js";
import Normalize from "../../helpers/Normalize.js";

import SocialLinks from "../../components/SocialLinks.svelte";
import SocialLinksSelect from "../../components/SocialLinksSelect.svelte";

export let show = false;
export let me = null;

let links = [
  {icon: "instagram", link: "@TheGroveLA"},
  {icon: "website", link: "thegrovela.com"},
];

let add = false;

$:{
  if (me) set();
}


function set() {
  links = me.socialLinks;
}


function addLink(e) {
  // console.log("e.detail:", e.detail);
  links.push(e.detail.link);
  links = links;
  add = false;
}


export const save = async () => {
  // eventually we'll do a compare here to verify changes...
  // if (xxx != me.xxx) {
    me.socialLinks = links;
    await profile.updateMe( { updateShare: true } );
  // }
}


</script>